<template>
    <div class="page-events">
        <!--banner-->
        <div class="banner">
            <div class="container">
                <h2 class="timeline">时光轴</h2>

            </div>
        </div>
        <!--content-->
        <div class="container">
            <div class="page">
                <el-carousel type="card" :autoplay="false" trigger="click" :initial-index="cur" arrow="always" :loop="false" indicator-position="none" @change="sort">
                    <el-carousel-item v-for="(y, index) in yearList" :key="index">{{y}}</el-carousel-item>
                </el-carousel>
                <!--timeline start-->
                <section id="cd-timeline" class="cd-container">
                    <div class="cd-timeline-block" v-for="(g, index) in gameList" :key="index">
                        <div class="cd-timeline-img cd-movie">
                            <img src="static/images/timeline/new.svg" alt="">
                        </div>

                        <div class="cd-timeline-content">
                            <h2>{{g.title}}</h2>
                            <p v-if="g.needHH !== 0">新增游戏《{{g.title}}》，并开始汉化。</p>
                            <p v-else>新增《{{g.title}}》。</p>
                            <router-link :to="'/game/'+g.path" class="cd-read-more  hvr-wobble-top" :title="g.title" target="_blank">
                                查看详情
                            </router-link>
                            <span class="cd-date">{{g.date}}</span>
                        </div>
                    </div>
                    <div class="cd-timeline-block" v-if="noData">
                        <div class="cd-timeline-img cd-movie">
                            <img src="static/images/timeline/new.svg" alt="">
                        </div>

                        <div class="cd-timeline-content">
                            <h2>Git游戏 建立</h2>
                            <p>Git游戏 旨在发现GitHub上面好玩的Html网页游戏，然后拉取过来，进行汉化，方便中国玩家玩耍。</p>
                            <a href="about.html" class="cd-read-more  hvr-wobble-top" target="_blank">查看更多</a>
                            <span class="cd-date">2017-10-26</span>
                        </div>
                    </div>

                </section>
                <!--timeline end-->
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Demo',
  components: {},
  data() {
    return {
      noData: false,
      cur: 0,
      gameList: [],
      yearList: []
    }
  },
  created() {
    this.getYear()
  },
  mounted() {},
  beforeDestroy() {
    this.gameList = []
  },
  methods: {
    getYear() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/year.json' + '?' + timeStamp).then(game => {
        for (var j = 0; j < game.data.length; j++) {
          this.yearList.push(game.data[j].year)
          if (game.data[j].current === 1) {
            // console.log(game.data[j].current)
            this.cur = j

        if(localStorage.getItem('gameList')){
          // 读取本地json
          this.sortStatic(j)
        } else {
            this.sort(j)
        }
            // console.log(this.cur)
          }
        }
      })
    },
    sort(i) {
      this.gameList = []
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/games.json' + '?' + timeStamp).then(game => {
        localStorage.setItem('gameList', JSON.stringify(game.data))
        for (var j = 0; j < game.data.length; j++) {
          if (game.data[j].status === 1) {
            var year = game.data[j].date.substr(0, 4)
            if (year === this.yearList[i]) {
              this.gameList.push(game.data[j])
              // console.log(this.yearList[i])
            }
          }
        }
        // 无数据时显示默认项
        if (this.gameList.length > 0) {
          this.noData = false
        } else {
          this.noData = true
        }
      })
    },
    sortStatic(i) {
      this.gameList = []
      var gameArr = JSON.parse(localStorage.getItem('gameList'))
        for (var j = 0; j < gameArr.length; j++) {
          if (gameArr[j].status === 1) {
            var year = gameArr[j].date.substr(0, 4)
            if (year === this.yearList[i]) {
              this.gameList.push(gameArr[j])
              // console.log(this.yearList[i])
            }
          }
        }
        // 无数据时显示默认项
        if (this.gameList.length > 0) {
          this.noData = false
        } else {
          this.noData = true
        }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
